<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout class="row wrap align-center justify-end row fill-height">
          <!-- <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                        <v-text-field
                            v-model="name"
                            label="Nome"
                            class="purple-input"
                            @keyup.enter="_search"
                        />
                    </v-flex> -->
          <v-flex xs12 sm12 md4 class="text-lg-left">
            <v-autocomplete
              :items="filteredPartners"
              item-text="name"
              item-value="id"
              prepend-icon="group_work"
              label="Parceiro"
              v-model="partner"
              return-object
              :rules="[
                (v) => !!v || 'Selecione o Parceiro que deseja ver o extrato',
              ]"
              no-data-text="Não há parceiros cadastrados nesse usuário"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 class="text-lg-left">
            <v-autocomplete
              :items="bankAccounts"
              item-text="bank_account.legal_name"
              item-value="bank_account.id"
              prepend-icon="account_balance"
              :hint="`${
                bankAccount.bank_account
                  ? 'Agência: ' +
                    bankAccount.bank_account.agencia +
                    ' | Conta: ' +
                    bankAccount.bank_account.conta +
                    '-' +
                    bankAccount.bank_account.conta_dv
                  : ''
              }`"
              label="Conta"
              v-model="bankAccount"
              :rules="[
                (v) => !!v || 'Selecione a Conta que deseja ver o extrato',
              ]"
              persistent-hint
              return-object
              single-line
              no-data-text="Não há contas cadastrados nesse parceiro"
            ></v-autocomplete>
            <!-- :hint="`${bankAccount.bank_account(bankAccount.bank_account?bankAccount.bank_account.agencia:'')} | ${bankAccount.bank_account?bankAccount.bank_account.conta:''}-${bankAccount.bank_account?bankAccount.bank_account.conta_dv:''}`" -->
          </v-flex>
          <v-flex xs12 sm12 md4 class="text-lg-left">
            <v-btn
              color="success"
              outline
              small
              slot="start"
              @click="_search"
              :disabled="!valid || loading"
              :loading="loading"
            >
              <v-icon left>search</v-icon>Buscar
            </v-btn>
          </v-flex>
          <!-- <v-flex
                      xs2
                      md2
                      class="text-lg-left"
                    >
                      <v-btn color="tertiary" small outline slot="start" @click="_clear" :disabled="!valid || loading">
                          <v-icon left>clear</v-icon>Limpar
                      </v-btn>
                    </v-flex> -->
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import {
  mapActions, //, mapGetters
  mapState,
  mapMutations,
} from "vuex";

export default {
  data: () => ({
    partner: "",
    bankAccount: "",
    valid: false,
  }),
  computed: {
    ...mapState("extrato", ["loading", "partners", "bankAccounts", "filter"]),
    ...mapState(["user"]),
    filteredPartners() {
      if (
        this.user.group.indexOf("admin") === 0 ||
        this.user.group.indexOf("financial") === 0
      )
        return this.partners;
      var PartnersArray = [];
      if (this.partners && this.user.partners) {
        this.partners.filter((partner) => {
          return this.user.partners.filter((partner2) => {
            if (partner2 === partner.id) {
              PartnersArray.push(partner);
            }
          });
        });
      }
      // console.log('PartnersArray.length: ', PartnersArray.length)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (PartnersArray.length === 1) this.partner = PartnersArray[0];
      return PartnersArray;
    },
    // filter () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.filter) return this.$store.state.cs.filter
    //     else return null
    // },
    // loading () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.loading) return this.$store.state.cs.loading
    //     else return false
    // },
    // billing () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.billing) return this.$store.state.cs.billing
    //     else return {}
    // }
  },
  mounted() {
    let params = {};
    if (
      this.user.group &&
      (this.user.group.indexOf("admin") >= 0 ||
        this.user.group.indexOf("financial") >= 0)
    ) {
      params.partners === "all";
    } else if (this.user.partners) {
      params.partners === this.user.partners;
    }
    //   console.log('params: ', params.partners)
    this.getPartners(params);
    if (this.filter) {
      this.partner = this.filter.partner || "";
      this.bankingAccout = this.filter.bankingAccout || "";
    }
  },
  watch: {
    filter(val) {
      this.partner = val.partner;
      this.bankingAccout = val.bankingAccout;
    },
    partner(val) {
      this.setBankAccounts([]);
      this.setFilter({ partner: val });
      this.setPartner(val);
      this.bankAccount = "";
      if (val.bankAccounts && val.bankAccounts.length > 0) {
        this.getBankAccounts(val.bankAccounts)
          .then((bankAccounts) => {
            // console.log('bankAccounts: ' , bankAccounts.length)
            if (bankAccounts.length === 1) this.bankAccount = bankAccounts[0];
          })
          .catch((err) => console.error("BankAccounts Error: ", err));
        this.getBalance(val.id);
      } else {
        console.error("Não possui contas cadastradas");
      }
    },
    bankAccount(val) {
      // this.setFilter({partner: this.partner, bankAccount: val})
      this.setBankAccount(val);
      this.getBalance(val.id);
      let params = {};
      params.recipient_id = val.id;
      let date = new Date();
      let end_date = new Date();
      params.startDate = date.setDate(date.getDate() - 8);
      params.endDate = end_date.setDate(end_date.getDate() + 1);
      this.getBalanceItems(params);

      params.bankAccount = val;
      params.partner = this.partner;
      this.setFilter(params);
      // console.log('params: ', params)
    },
  },
  methods: {
    ...mapMutations("extrato", [
      "setFilter",
      "setBankAccounts",
      "setPartner",
      "setBankAccount",
    ]),
    ...mapActions("extrato", [
      "resetFilter",
      "getBalance",
      "getBankAccounts",
      "getPartners",
      "getBalanceItems",
    ]),
    _search() {
      // this.resetFilter()
      // this.loading = true
      let params = {};
      if (this.partner) {
        params.partner = this.partner;
      }
      if (this.bankAccount) {
        params.bankAccount = this.bankAccount;
      }
      let date = new Date();
      let end_date = new Date();
      params.startDate = date.setDate(date.getDate() - 8);
      params.endDate = end_date.setDate(end_date.getDate() + 1);
      params.recipient_id = this.bankAccount.id;
      this.setFilter(params);
      this.getBalance(this.bankAccount.id);
      // console.log('params: ', params)
      this.getBalanceItems(params);
    },
    _clear() {
      this.partner = "";
      this.bankAccount = "";
      this.resetFilter();
      return;
    },
  },
  beforeDestroy() {},
};
</script>
